<!--
 * @Descripttion: 这是测试
 * @version: 
 * @Author: 123
 * @Date: 2023-11-02 14:51:54
 * @LastEditors: 123
 * @LastEditTime: 2025-02-10 10:37:20
-->
<template>
  <section class="page-header-wrapper page-header">
    <div class="title-background txt-center font-14 p-r">
      <div class="p-a font-24" @click="goBack" v-show="back">
        <svg-icon icon-class="back" />
      </div>
      <div>{{ detail }}</div>
      <div class="p-a down_" @click="handleDownDPF" v-if="downFlag">下载</div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "cElPageHeader",
  components: {},
  props: {
    detail: {
      type: String,
      default: "title"
    },
    downFlag:{
      type: Boolean,
      default: false
    },
    back: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    ...mapGetters(['pdfData'])
  },
  methods: {
    goBack() {
      this.$router.back(-1)
    },
    handleDownDPF(){
      this.pdfData.forEach(element => {
        window.location.href = `${element.getFilePath[0]}` 
      });
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scope>
.page-header-wrapper {
  color: #fff;
}
.down_ {
  right: 24px;
  top: 0;
}
</style>
